export const RiskAssessmentBody = {
    stdInfo: {},
    inputB_1: "",
    inputB_2: "",
    inputB_3: "",
    inputB_4: "",
    inputB_5: "",
    inputB_6: "",
    inputB_7: "",
    inputB_8: "",
    inputB_9: "",
    inputB_10: {},
    inputB_11: "",
    photoList: [
      { id: null, path: null, fileName: null, input: "" },
      { id: null, path: null, fileName: null, input: "" },
    ],
    photoListAfter: [
      { id: null, path: null, fileName: null, input: "" },
      { id: null, path: null, fileName: null, input: "" },
    ],
    fileList: [],
    riskAppraisalList: [],
    riskAppraisalList2: [
    ],
    disasters: "",
    employeeList: [],
    isFinishLater: false,
  };
  